import { put, call, takeEvery, takeLatest } from 'redux-saga/effects';

import Actions from '../Actions/Creators';
import Types from '../Actions/Types';
import Phi from '../Phi/Phi';

import FileSaver from 'file-saver';
import Constants from '../Phi/Constants';


const formatResponseProgram = (responseProgram) => responseProgram.length && responseProgram[0].org_count && JSON.parse(responseProgram[0].org_count) && JSON.parse(responseProgram[0].org_count).org ? JSON.parse(responseProgram[0].org_count).org.organization : []

const formatAssessmentResponse = (responseAssessment) => responseAssessment.length && responseAssessment[0].start_nodes_json && JSON.parse(responseAssessment[0].start_nodes_json) && JSON.parse(responseAssessment[0].start_nodes_json).array_agg && JSON.parse(responseAssessment[0].start_nodes_json).array_agg.length ? JSON.parse(responseAssessment[0].start_nodes_json).array_agg : []

const getEvents = (programs = [] , eventName) => programs && programs.map(program => program && program.events.filter(event => event.event_custom_json.name === eventName)[0]) 

const selectedPrograms = (programList, startNodeId) => startNodeId.map(currentStartNodeId => programList.filter(j => j.events[0].id === currentStartNodeId.event_track_id)[0])

const getVendorLogo = (allDocs) => {
    const customField = allDocs && allDocs.length && allDocs[0].custom_field && JSON.parse(allDocs[0].custom_field) || null
    if(Boolean(customField) && customField.length){
        return customField.reduce((vendorLogo, currentValue) => currentValue && currentValue.json_value && currentValue.json_value.type === "vendorLogo" ? currentValue.json_value.content_url : vendorLogo, null)
    }
    return null
}
function* getVendorImages (vendorIds = []) {
    let imageUrls = []
    for(let i = 0 ; i < vendorIds.length; i++){
        try {
            const currentVendor = yield call(Phi.Organization.getOrganization, Phi.Organization, vendorIds[i])
            const vendorContentId = currentVendor.inOrganizationCustomJson.vendorContentID || null
            const payload = Boolean(vendorContentId) ? {
                "sourceNodeUUID": vendorContentId,
                "targetNodeUUID": null,
                "relationType": null
            } : null
            const allDocs = Boolean(payload) ? yield call(Phi.Organization.getContentAssociation, Phi.Organization, payload) : null
            const vendorLogo = getVendorLogo(allDocs)
            Boolean(vendorLogo) && imageUrls.push(vendorLogo)
        } catch (e) {
            console.warn(e)
        }
    }
    return imageUrls.filter(i => Boolean(i))
}

function removeDuplicates( arr, prop ) {
    let obj = {};
    for ( let i = 0, len = arr.length; i < len; i++ ){
        if(!obj[arr[i][prop]]) obj[arr[i][prop]] = arr[i];
    }
    let newArr = [];
    for ( let key in obj ) newArr.push(obj[key]);
    return newArr;
}

const sortByEventTrackId = (eventArray = []) => eventArray.sort((a,b) => (a.event_track_id - b.event_track_id ? true : false)).reverse()

/**
 * 
 * Get All Associations
 * 
 * @param {*} action Contains parentId (userId) and studentId 
 */
function* fetchChildList(action) {

    const userId = action.params.userId
    const currentStuId = action.params.studentId

    //const responseChild = yield call(Phi.User.getUserAssociation, Phi.User, {userId: userId});
  let responseChild = yield call(Phi.User.getParentStudentAssociation, Phi.User, {userId: userId});
    
    if(Boolean(responseChild)) {
    
        // yield put(Actions.responseChildList({ ok: true, childList: responseChild, selectedChild: index }));

        let showStudentVerificationModal = responseChild.filter((element, i) => element.associationActive === Constants.activeStatusMap.DRAFT)
        showStudentVerificationModal = Boolean(showStudentVerificationModal.length)

        let userOrganization = Phi.Storage.getItem('organization')
        let userProfile = Phi.Storage.getItem('profile')
        let userRole = Phi.Storage.getItem('roles')

        userOrganization = userOrganization && JSON.parse(userOrganization) && JSON.parse(userOrganization)[0] || {}
        userProfile = userProfile && JSON.parse(userProfile) || {}
        userRole = userRole && JSON.parse(userRole)[0] || {}

        if ( userRole.role_type_id === Constants.roleIdMap.TEACHER || userRole.role_type_id === Constants.roleIdMap.NON_TEACHING || userRole.role_type_id === Constants.roleIdMap.DEFAULT_SIGNUP ) {
            if ( responseChild && responseChild.length ){
                try {
                    responseChild = responseChild.asMutable()
                }catch (e) {

                }
                responseChild.unshift({
                    userId: userProfile.user_id,
                    schoolId: userOrganization.org_id,
                    role: userRole.role_type_id,
                    name: `${userProfile.firstname} ${userProfile.lastname}`
                })
    
            }
        }

        let index = 0
        // Setting up selected student (Durring parent login from third party portal)
        if (currentStuId) {
            try {
                var val = parseInt(currentStuId)
                var filteredObj = responseChild.find(function(item, i){
                    if(item.userId === val){
                        index = i;
                        return i;
                    }
                });
            }catch(e){
                //Catch Empty!!! Raise Error 
                yield put(Actions.responseChildList({ ok: false, error: 'Failed to fetch any associated students' }));
            }
        }

        yield put(Actions.responseChildList({ ok: true, childList: responseChild, selectedChild: index, showStudentVerificationModal:showStudentVerificationModal }));
    }

    else {
        yield put(Actions.responseChildList({ ok: false, error: 'Failed to fetch any associated students' }));
    }
}


// function* fetchChildList(action) {
//     const childList = [];

//     const userId = action.params.userId
//     const currentStuId = action.params.studentId

//     const responseChild = yield call(Phi.User.getUserAssociation, Phi.User, {userId: userId});
    
//     if(Boolean(responseChild)) {
//         for(let pos=0 ; pos < responseChild.length ; pos++) {
//             const item = responseChild[pos];

//             const orgId = JSON.parse(item.org)[0].org_id;
//             const responseAssessment = yield call(Phi.Organization.fetchStudentAssessmentHistory, Phi.Organization, {userId: item.id});
//             // const responseOrg = yield call(Phi.Organization.getOrganization, Phi.Organization, orgId);
//             const responseProgram = yield call(Phi.Event.fetchProgramList, Phi.Event, {inOrganizationId: orgId})
//             const programs = selectedPrograms(formatResponseProgram(responseProgram), formatAssessmentResponse(responseAssessment)) || []
//             const events = getEvents(programs, "Start Node") || []
//             let mspDetails = []
//             for(let i = 0; i < events.length; i ++){
//                 let event = events[i]
//                 event && event.event_custom_json && event.event_custom_json.imageURL ? mspDetails.push({
//                     partnerLogo : event.event_custom_json.imageURL
//                 }) : event && event.event_custom_json && event.event_custom_json.msp ? mspDetails.push({
//                     partnerLogo: yield getVendorImages(event.event_custom_json.msp)
//                 }) : mspDetails.push({
//                     partnerLogo: false
//                 })
//             }
//             if(!Boolean(responseAssessment.error) && Boolean(responseAssessment)) {
//                 childList.push({
//                     userId: item.id,
//                     uuId: item.uuid,
//                     name: String((item.profile.firstname || '') + ' ' + (item.profile.lastname || '')).trim(),
//                     gender: item.profile.gender,
//                     profile: item.profile,
//                     custom: item.custom.json_value,
//                     assessmentList: JSON.parse(responseAssessment[0].start_nodes_json) && JSON.parse(responseAssessment[0].start_nodes_json).array_agg && sortByEventTrackId(removeDuplicates(JSON.parse(responseAssessment[0].start_nodes_json).array_agg, 'event_track_id')),
//                     schoolId: orgId,
//                     mspDetails,
//                     schoolName: programs[0] && programs[0].organization_name,
//                     schoolCountry: programs[0] && programs[0].country_name,
//                     schoolState: programs[0] && programs[0].state_name,
//                     schoolCity: programs[0] && programs[0].district_name
//                 });
//             }
            
//         }

//         let index = 0

//         if (currentStuId) {
//             try {
//                 var val = parseInt(currentStuId)
//                 var filteredObj = childList.find(function(item, i){
//                     if(item.userId === val){
//                         index = i;
//                         return i;
//                     }
//                 });
//             }catch(e){

//             }
//         }
        

//         yield put(Actions.responseChildList({ ok: true, childList, selectedChild: index }));
//     }

//     else {
//         yield put(Actions.responseChildList({ ok: false, error: 'Failed to fetch any associated students' }));
//     }
// }


function* fetchStudentAssessmentStatus(action) {
    const params = {
        userId: action.userId,
        eventTrackId: action.eventTrackId
    };

    const response = yield call(Phi.Organization.fetchStudentAssessmentStatus, Phi.Organization, params);

    if(!Boolean(response.error)) {
        yield put(Actions.responseStudentAssessmentStatus({ok: true, statusList: response}));
    }

    else {
        yield put(Actions.responseStudentAssessmentStatus({ok: false}));
    }
}


function* fetchPentahoReport(action) {
    const params = {
        reportName: action.reportName,
        reportParams: {
            type: 'html',
            studentId: action.studentId,
            startNodeId: action.startNodeId
        }
    };

    const responseReport = yield call(Phi.Organization.fetchPentahoReport, Phi.Organization, params, false);

    if(!Boolean(responseReport.error) && Boolean(responseReport.data)) {
        yield put(Actions.responsePentahoReport({ok: true, report: responseReport.data}));
    }
    else {
        yield put(Actions.responsePentahoReport({ok: false, error: responseReport.error || 'Failed to fetch report'}));
    }
}


function* downloadPentahoReport(action) {
    const params = {
        reportName: action.reportName,
        reportParams: {
            type: 'pdf',
            studentId: action.studentId,
            startNodeId: action.startNodeId
        }
    };

    const responseReport = yield call(Phi.Organization.fetchPentahoReport, Phi.Organization, params, true);

    if(!Boolean(responseReport.error) && Boolean(responseReport.data)) {
        FileSaver.saveAs(responseReport.data, action.reportName + ' report');
    }
    else {
        alert('Failed to download Report.');
    }
}



function* addChildUsingActiviationCode(action) {
    if(!Boolean(action.params.userName) ||
    !Boolean(action.params.activationCode) ||
    !Boolean(action.params.dob)) {
        yield put(Actions.responseAddChildUsingActivationCode({ ok: false, error: 'Invalid Parameters' }));
        return;
    }

    const params = {
        userName: action.params.userName,
        activationCode: action.params.activationCode,
        dob: action.params.dob
    };

    const response = yield call(Phi.User.addUserAssociationUsingActivationCode, Phi.User, params);

    if(Boolean(response) && !Boolean(response.error) && response.status === 200) {
        yield put(Actions.responseAddChildUsingActivationCode({ ok: true, error: null }));
    }
    else {
        yield put(Actions.responseAddChildUsingActivationCode({ ok: false, error: response.error || 'Failed to associate child' }));
    }
}



function* postExpertQueries(action) {
    const response = yield call(Phi.Organization.postExpertQueries, Phi.Organization, action.params);

    if(response.ok) {
        yield put(Actions.responseExpertQueries({status: true}));
    }
    else {
        yield put(Actions.responseExpertQueries({status: false, error: response.error}));
    }
}



function* postAppointmentRequest(action) {
    const response = yield call(Phi.Organization.postAppointmentRequest, Phi.Organization, action.params);

    if(response.ok) {
        yield put(Actions.responseAppointmentRequest({status: true}));
    }
    else {
        yield put(Actions.responseAppointmentRequest({status: false, error: response.error}));
    }
}


function* getDMFTIndex(action) {
    const { startNodeId, studentId } = action

    const response = yield call(Phi.Organization.fetchDMFTIndex, Phi.Organization, action);

    if(!Boolean(response.error)) {
        yield put(Actions.updateDMFTIndex(response))
    } else {
        yield put(Actions.updateDMFTIndex( {error: response} ))
    }

}


function* getVaccination(action) {
    const response = yield call(Phi.Organization.getVaccination, Phi.Organization);

    if(Boolean(response) && response.ok) {
        yield put(Actions.responseVaccination({ok: true, data: response.data.results}));
    }

    else {
        yield put(Actions.responseVaccination({ok: false}));
    }
}

function* getS3Access() {
    const response = yield call(Phi.Organization.getS3Credentials, Phi.Organization, {request: "getAccess"});

    if(response) {
        yield put(Actions.responseS3Access(response));
    }else {
        yield put(Actions.responseS3Access({}));
    }
}

// Saga Watcher
export function* watchActions() {
    yield* [
        takeEvery(Types.FETCH_CHILD_LIST, fetchChildList),
        takeEvery(Types.FETCH_STUDENT_ASSESSMENT_STATUS, fetchStudentAssessmentStatus),
        takeLatest(Types.FETCH_PENTAHO_REPORT, fetchPentahoReport),
        takeEvery(Types.DOWNLOAD_PENTAHO_REPORT, downloadPentahoReport),
        takeEvery(Types.ADD_CHILD_USING_ACTIVATION_CODE, addChildUsingActiviationCode),
        takeEvery(Types.POST_EXPERT_QUERIES, postExpertQueries),
        takeEvery(Types.POST_APPOINTMENT_REQUEST, postAppointmentRequest),
        takeEvery(Types.GET_DMFT_INDEX, getDMFTIndex),
        takeEvery(Types.FETCH_VACCINATION, getVaccination),

        takeLatest(Types.GET_S3_ACCESS, getS3Access)
    ]
}